var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadContantIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.6666H14.5V14H2.5V12.6666ZM9.16667 3.8856V11.3333H7.83333V3.8856L3.78595 7.93298L2.84315 6.99018L8.5 1.33331L14.1569 6.99018L13.2141 7.93298L9.16667 3.8856Z",
    fill: "#3F4753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadContantIcon);
export default __webpack_public_path__ + "static/media/upload-contant-icon.58ba40c22aba3c4def723ff30f8db83a.svg";
export { ForwardRef as ReactComponent };